export enum TipoDePersonaEnum {
    Natural = 1,
    Juridica = 2,
}